import React, { useState } from 'react';
import { XIcon, SaveIcon, BookOpenIcon } from 'lucide-react';
interface WritingEditorProps {
  initialContent: string;
  promptTitle: string;
  promptText: string;
  onSave: (content: string) => void;
  onClose: () => void;
  activityId: string;
}
const WritingEditor: React.FC<WritingEditorProps> = ({
  initialContent,
  promptTitle,
  promptText,
  onSave,
  onClose,
  activityId
}) => {
  const [content, setContent] = useState(initialContent);
  const [isSaving, setIsSaving] = useState(false);
  const handleSave = () => {
    setIsSaving(true);
    // Simulate saving delay
    setTimeout(() => {
      onSave(content);
      setIsSaving(false);
    }, 500);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-83">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col" data-id="element-84">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b" data-id="element-85">
          <div className="flex items-center" data-id="element-86">
            <BookOpenIcon className="text-green-600 mr-2" size={20} data-id="element-87" />
            <h2 className="text-xl font-semibold text-gray-800" data-id="element-88">
              {promptTitle}
            </h2>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100" data-id="element-89">
            <XIcon size={20} data-id="element-90" />
          </button>
        </div>
        {/* Prompt */}
        <div className="p-4 bg-green-50 border-b border-green-100" data-id="element-91">
          <p className="text-gray-700" data-id="element-92">{promptText}</p>
        </div>
        {/* Editor */}
        <div className="flex-grow overflow-auto p-4" data-id="element-93">
          <textarea value={content} onChange={e => setContent(e.target.value)} className="w-full h-full min-h-[300px] p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none resize-none" placeholder="Begin writing here..." data-id="element-94" />
        </div>
        {/* Footer */}
        <div className="p-4 border-t flex justify-between items-center" data-id="element-95">
          <div className="text-sm text-gray-500" data-id="element-96">
            {content.length > 0 ? <>
                <span className="font-medium" data-id="element-97">
                  {content.trim().split(/\s+/).filter(Boolean).length}
                </span>{' '}
                words,
                <span className="font-medium ml-1" data-id="element-98">{content.length}</span>{' '}
                characters
              </> : 'Start writing to see word count'}
          </div>
          <div className="flex space-x-3" data-id="element-99">
            <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50" data-id="element-100">
              Cancel
            </button>
            <button onClick={handleSave} disabled={isSaving} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center" data-id="element-101">
              {isSaving ? <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" data-id="element-102"></div>
                  Saving...
                </> : <>
                  <SaveIcon size={18} className="mr-1" data-id="element-103" />
                  Save
                </>}
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default WritingEditor;